import { Box, Text } from '@factorialco/deprecated-design-system'
import { ProcessesProcessCategoryEnum } from 'generated/resources/graphql'

import { dateToString, stringToDate } from 'modules/core/lib/dates'

import { labelColor } from 'modules/processes/components/MaterializedProcessesTable/MaterializedProcessName'

interface Props {
  contractStartsOn?: string | null
  contractEndsOn?: string | null
  status?: string | null
  processCategory: ProcessesProcessCategoryEnum
}

export const ContractDate = ({
  contractStartsOn,
  contractEndsOn,
  status,
  processCategory,
}: Props) => {
  const isBoarding = ['onboarding', 'offboarding'].includes(processCategory)

  if (!isBoarding) return <></>

  const formatDate = (date?: string | null) => {
    return date ? dateToString(stringToDate(date, 'backend_datetime'), 'ui') : '-'
  }

  const date =
    processCategory === 'onboarding' ? formatDate(contractStartsOn) : formatDate(contractEndsOn)

  return (
    <Box gap="s12" flexDirection="row" alignItems="center" justifyContent="center">
      <Text.Normal lineClamp={2} color={labelColor(status)}>
        {date}
      </Text.Normal>
    </Box>
  )
}
